import {useAtomValue} from 'jotai';
import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {useQueryRegionByPoint} from '@/map/api';
import {mapCenterAtom} from '@/map/atom';
import {MAP_QUERY_DEBOUNCE_MS} from '@/map/constants';
import {GeoDataType} from '@/map/enums';
import {palette} from '@/styles';

interface IProps {
  map?: naver.maps.Map;
}

// const REGION_TYPES = Object.values(RegionTypes);

export const RegionController = (props: IProps) => {
  // const defaultRegion = [
  //   {
  //     type: RegionTypes.ctprvn,
  //   },
  // ];
  const mapCenter = useAtomValue(mapCenterAtom);
  const {data, isPending} = useQueryRegionByPoint(
    !!mapCenter && {
      lng: mapCenter.x,
      lat: mapCenter.y,
      type: GeoDataType.Emd,
    },
    MAP_QUERY_DEBOUNCE_MS
  );
  // const [regions, setRegions] = useState<
  //   Array<{
  //     name?: string;
  //     code?: string;
  //     parentCode?: string;
  //     type: RegionTypes;
  //   }>
  // >(defaultRegion);

  // useEffect(() => {
  //   if (data) {
  //     const property = data;

  //     if (property) {
  //       setRegions([
  //         {
  //           name: property.sido,
  //           code: property.sidoCode,
  //           type: RegionTypes.ctprvn,
  //         },
  //         {
  //           name: property.sgg,
  //           code: property.sggCode,
  //           parentCode: property.sido,
  //           type: RegionTypes.sig,
  //         },
  //         {
  //           name: property.emd,
  //           code: property.admCode,
  //           parentCode: property.sggCode,
  //           type: RegionTypes.emd,
  //         },
  //       ]);
  //     } else {
  //       setRegions(defaultRegion);
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data]);

  return (
    <Root>
      <Typography
        variant="medium14"
        color={isPending ? palette.gray400 : palette.gray800}
      >
        {data?.name || '지역 검색 중...'}
      </Typography>
      {/* {REGION_TYPES.map((i, idx) => (
        <React.Fragment key={i}>
          <RegionSelector index={idx} {...regions?.[idx]} {...props} />
          {idx + 1 !== REGION_TYPES.length && (
            <Arrow disabled={regions?.length <= 1}>
              <DropupIconComponent />
            </Arrow>
          )}
        </React.Fragment>
      ))} */}
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  align-items: center;
  background-color: ${palette.white};
  padding: 4px 12px;
  border-radius: 25px;
  border: solid 1px ${palette.gray300};
  box-shadow: 0px 4px 10px 0px #00000026;
`;

// const Arrow = styled.button`
//   display: flex;
//   flex-shrink: 0;
//   width: 12px;
//   height: 12px;
//   transform: rotate(90deg);
//   &:disabled {
//     opacity: 0.3;
//   }
// `;
